import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { SquareCheckbox } from '@Components/controls/Checkbox/Checkbox';
import ConditionalRender from '@Components/ConditionalRender/ConditionalRender';
import useTranslate from '@Utils/hooks/useTranslate';
import { IAddress } from '@ApiModels/commerceProfile';
import { ICartItem, IInsuranceCartItem } from '@ApiModels/viewCart';
import { isUserSignedIn } from '@Redux/modules/api/authentication/selectors';
import PageContent from './PageContent';
import AddressBookDetails from '../../AddressBook/AddressBookDetails';

interface INotHBBWFBB {
	hbbWfbbItem: ICartItem | IInsuranceCartItem | undefined;
	hbbWfbbInternetInstallationAddress: IAddress | undefined;
	saveAddress: boolean | undefined;
	setAdditionalLandmark: ((landmark: string) => void) | undefined;
	setSaveAddress: ((val: boolean) => void) | undefined;
}

const HBBWFBB = ({
	hbbWfbbItem,
	hbbWfbbInternetInstallationAddress,
	saveAddress,
	setAdditionalLandmark,
	setSaveAddress,
}: INotHBBWFBB): JSX.Element => {
	const history = useHistory();
	const { translate } = useTranslate();
	const isGuest = useSelector((state: types.redux.IState) => state.api.authentication.loginType === 'guest');
	const showSaveAddressCheckbox = (): boolean => isUserSignedIn() && !isGuest;

	const handleEditButton = () => {
		history.push('/map', { editAddress: true });
	};

	const iconName = hbbWfbbItem ? 'house' : 'shipping';

	return (
		<PageContent
			title={translate('shipping-method.title.hbb.wfbb')}
			description={translate('shipping-method.title.hbb.wfbb.desc')}
			name={iconName}
		>
			<>
				<ConditionalRender
					show={!!hbbWfbbItem}
					onTrue={() => (
						<>
							{hbbWfbbInternetInstallationAddress && (
								<AddressBookDetails
									address={hbbWfbbInternetInstallationAddress}
									isHbbWfbbProcess={!!hbbWfbbItem}
									editLandmark={setAdditionalLandmark}
									editAddress={() => {}}
									onEditButtonClick={handleEditButton}
									divider={0}
								/>
							)}
						</>
					)}
				/>
				<ConditionalRender
					show={showSaveAddressCheckbox()}
					onTrue={() => (
						<SquareCheckbox
							active={!!saveAddress}
							onChange={() => {
								setSaveAddress && setSaveAddress(!saveAddress);
							}}
							disabled={false}
							label={translate('shipping.method.save-address')}
							labelClickable
						/>
					)}
				/>
			</>
		</PageContent>
	);
};

export default HBBWFBB;
